var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterCommmentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#657786;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,2.2l-4.1,0h0c-4.4,0-7.8,3.4-7.8,7.8c0,4.1,3.2,7.2,7.5,7.4v3.8c0,0.1,0,0.3,0.1,0.4 c0.1,0.2,0.4,0.3,0.6,0.3c0.1,0,0.3,0,0.4-0.1c0.3-0.2,6.5-4.1,8.1-5.5c1.9-1.6,3-4,3-6.3v0C21.8,5.7,18.4,2.2,14,2.2L14,2.2z  M17.8,15.2c-1.1,1-4.9,3.4-6.8,4.6v-3.2c0-0.4-0.3-0.8-0.8-0.8H9.9c-3.7,0-6.3-2.5-6.3-5.9c0-3.5,2.8-6.3,6.3-6.3l4.1,0h0 c3.5,0,6.3,2.8,6.3,6.3C20.3,11.9,19.4,13.9,17.8,15.2L17.8,15.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterCommmentIcon);
export default __webpack_public_path__ + "static/media/twitter-commment-icon.5c28fbefeb8a8a8c7ac80bffc8f230ad.svg";
export { ForwardRef as ReactComponent };